import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export const getReplenishmentThresholdsCsv = async (
    warehouseId: string,
    locationId?: string,
    productId?: string,
    callback?: CallbackObject<void>
) => {
    const config: Record<string, any> = {
        headers: {
            'Content-Type': 'application/json'
        },
        params: {},
        responseType: 'blob', // Important for file download
    };

    if (locationId) {
        config.params.locationId = locationId;
    }

    if (productId) {
        config.params.productId = productId;
    }

    try {
        const res = await instance.get(`/replenishment/warehouses/${warehouseId}/thresholds/csv`, config);

        // Create blob and download file
        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `thresholds.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        if (callback?.success) callback.success();
    } catch (err) {
        if (callback?.error) callback.error(err);
    }
};
